<template>
  <button class="look-button">
    <svg class="look-button__icon"><use xlink:href="#svg-basket"></use></svg>
    <DefSlide :active="isHover" :x="true" tag="span">&nbsp;&nbsp; <slot /></DefSlide>
  </button>
</template>

<script lang="ts" setup>
import DefSlide from '@components/Def/DefSlide/DefSlide.vue';

const props = defineProps<{ isHover: boolean }>();
</script>

<style lang="scss" scoped>
.look-button {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 16px;
  left: 16px;
  height: 40px;
  padding: 0 10px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  text-wrap: nowrap;
  transition: 0.2s linear background-color;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  &__icon {
    width: 20px;
    height: 20px;
  }
  &:hover {
    background-color: #fff;
  }
}
</style>
